import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map, share } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ServiceProviderType = /*#__PURE__*/function (ServiceProviderType) {
  ServiceProviderType[ServiceProviderType["SERVICE_PROVIDER_TYPE_PRODUCT"] = 0] = "SERVICE_PROVIDER_TYPE_PRODUCT";
  ServiceProviderType[ServiceProviderType["SERVICE_PROVIDER_TYPE_PLATFORM"] = 1] = "SERVICE_PROVIDER_TYPE_PLATFORM";
  return ServiceProviderType;
}(ServiceProviderType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ServiceContextAccount {
  static fromProto(proto) {
    let m = new ServiceContextAccount();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    return toReturn;
  }
}
class AutoImpersonation {
  static fromProto(proto) {
    let m = new AutoImpersonation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ServiceContextBrand {
  static fromProto(proto) {
    let m = new ServiceContextBrand();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupPath !== 'undefined') {
      toReturn['groupPath'] = this.groupPath;
    }
    return toReturn;
  }
}
class NoImpersonation {
  static fromProto(proto) {
    let m = new NoImpersonation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ServiceContextPartner {
  static fromProto(proto) {
    let m = new ServiceContextPartner();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ServiceContext {
  static fromProto(proto) {
    let m = new ServiceContext();
    m = Object.assign(m, proto);
    if (proto.account) {
      m.account = ServiceContextAccount.fromProto(proto.account);
    }
    if (proto.partner) {
      m.partner = ServiceContextPartner.fromProto(proto.partner);
    }
    if (proto.superAdmin) {
      m.superAdmin = ServiceContextSuperAdmin.fromProto(proto.superAdmin);
    }
    if (proto.brand) {
      m.brand = ServiceContextBrand.fromProto(proto.brand);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.account !== 'undefined' && this.account !== null) {
      toReturn['account'] = 'toApiJson' in this.account ? this.account.toApiJson() : this.account;
    }
    if (typeof this.partner !== 'undefined' && this.partner !== null) {
      toReturn['partner'] = 'toApiJson' in this.partner ? this.partner.toApiJson() : this.partner;
    }
    if (typeof this.superAdmin !== 'undefined' && this.superAdmin !== null) {
      toReturn['superAdmin'] = 'toApiJson' in this.superAdmin ? this.superAdmin.toApiJson() : this.superAdmin;
    }
    if (typeof this.brand !== 'undefined' && this.brand !== null) {
      toReturn['brand'] = 'toApiJson' in this.brand ? this.brand.toApiJson() : this.brand;
    }
    return toReturn;
  }
}
class ServiceContextSuperAdmin {
  static fromProto(proto) {
    let m = new ServiceContextSuperAdmin();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AcsUrl {
  static fromProto(proto) {
    let m = new AcsUrl();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.binding !== 'undefined') {
      toReturn['binding'] = this.binding;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    return toReturn;
  }
}
class SamlServiceProviderConfig {
  static fromProto(proto) {
    let m = new SamlServiceProviderConfig();
    m = Object.assign(m, proto);
    if (proto.acsUrls) {
      m.acsUrls = proto.acsUrls.map(AcsUrl.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    if (typeof this.acsUrls !== 'undefined' && this.acsUrls !== null) {
      toReturn['acsUrls'] = 'toApiJson' in this.acsUrls ? this.acsUrls.toApiJson() : this.acsUrls;
    }
    if (typeof this.signedAuthRequest !== 'undefined') {
      toReturn['signedAuthRequest'] = this.signedAuthRequest;
    }
    if (typeof this.wantSignedAssertion !== 'undefined') {
      toReturn['wantSignedAssertion'] = this.wantSignedAssertion;
    }
    if (typeof this.wantEncryptedAssertion !== 'undefined') {
      toReturn['wantEncryptedAssertion'] = this.wantEncryptedAssertion;
    }
    if (typeof this.nameIdFormats !== 'undefined') {
      toReturn['nameIdFormats'] = this.nameIdFormats;
    }
    if (typeof this.signingCertificate !== 'undefined') {
      toReturn['signingCertificate'] = this.signingCertificate;
    }
    if (typeof this.encryptionCertificate !== 'undefined') {
      toReturn['encryptionCertificate'] = this.encryptionCertificate;
    }
    if (typeof this.serviceProviderConfigId !== 'undefined') {
      toReturn['serviceProviderConfigId'] = this.serviceProviderConfigId;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    return toReturn;
  }
}
class ServiceProviderConfig {
  static fromProto(proto) {
    let m = new ServiceProviderConfig();
    m = Object.assign(m, proto);
    if (proto.serviceProviderType) {
      m.serviceProviderType = enumStringToValue$5(ServiceProviderType, proto.serviceProviderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    if (typeof this.sessionUrl !== 'undefined') {
      toReturn['sessionUrl'] = this.sessionUrl;
    }
    if (typeof this.primaryDomain !== 'undefined') {
      toReturn['primaryDomain'] = this.primaryDomain;
    }
    if (typeof this.alternativeDomains !== 'undefined') {
      toReturn['alternativeDomains'] = this.alternativeDomains;
    }
    if (typeof this.ownedAndOperated !== 'undefined') {
      toReturn['ownedAndOperated'] = this.ownedAndOperated;
    }
    if (typeof this.logoutUrl !== 'undefined') {
      toReturn['logoutUrl'] = this.logoutUrl;
    }
    if (typeof this.serviceProviderType !== 'undefined') {
      toReturn['serviceProviderType'] = this.serviceProviderType;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Oauth2Config {
  static fromProto(proto) {
    let m = new Oauth2Config();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.redirectUris !== 'undefined') {
      toReturn['redirectUris'] = this.redirectUris;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.logoutUri !== 'undefined') {
      toReturn['logoutUri'] = this.logoutUri;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Scope {
  static fromProto(proto) {
    let m = new Scope();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class IdentityProviderConfiguration {
  static fromProto(proto) {
    let m = new IdentityProviderConfiguration();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.openId) {
      m.openId = OpenIDConnectConfiguration.fromProto(proto.openId);
    }
    if (proto.oauth2) {
      m.oauth2 = OAuth2Configuration.fromProto(proto.oauth2);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.openId !== 'undefined' && this.openId !== null) {
      toReturn['openId'] = 'toApiJson' in this.openId ? this.openId.toApiJson() : this.openId;
    }
    if (typeof this.oauth2 !== 'undefined' && this.oauth2 !== null) {
      toReturn['oauth2'] = 'toApiJson' in this.oauth2 ? this.oauth2.toApiJson() : this.oauth2;
    }
    return toReturn;
  }
}
class OAuth2Configuration {
  static fromProto(proto) {
    let m = new OAuth2Configuration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.authorizationEndpoint !== 'undefined') {
      toReturn['authorizationEndpoint'] = this.authorizationEndpoint;
    }
    if (typeof this.tokenEndpoint !== 'undefined') {
      toReturn['tokenEndpoint'] = this.tokenEndpoint;
    }
    if (typeof this.userinfoEndpoint !== 'undefined') {
      toReturn['userinfoEndpoint'] = this.userinfoEndpoint;
    }
    return toReturn;
  }
}
class OpenIDConnectConfiguration {
  static fromProto(proto) {
    let m = new OpenIDConnectConfiguration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.discoveryEndpoint !== 'undefined') {
      toReturn['discoveryEndpoint'] = this.discoveryEndpoint;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetMultiConfigResponseConfigContainer {
  static fromProto(proto) {
    let m = new GetMultiConfigResponseConfigContainer();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = Oauth2Config.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class CreateConfigRequest {
  static fromProto(proto) {
    let m = new CreateConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.redirectUris !== 'undefined') {
      toReturn['redirectUris'] = this.redirectUris;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.logoutUri !== 'undefined') {
      toReturn['logoutUri'] = this.logoutUri;
    }
    return toReturn;
  }
}
class CreateConfigResponse {
  static fromProto(proto) {
    let m = new CreateConfigResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.clientSecret !== 'undefined') {
      toReturn['clientSecret'] = this.clientSecret;
    }
    return toReturn;
  }
}
class CreateIdentityProviderConfigurationRequest {
  static fromProto(proto) {
    let m = new CreateIdentityProviderConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.openId) {
      m.openId = OpenIDConnectConfiguration.fromProto(proto.openId);
    }
    if (proto.oauth2) {
      m.oauth2 = OAuth2Configuration.fromProto(proto.oauth2);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.clientSecret !== 'undefined') {
      toReturn['clientSecret'] = this.clientSecret;
    }
    if (typeof this.openId !== 'undefined' && this.openId !== null) {
      toReturn['openId'] = 'toApiJson' in this.openId ? this.openId.toApiJson() : this.openId;
    }
    if (typeof this.oauth2 !== 'undefined' && this.oauth2 !== null) {
      toReturn['oauth2'] = 'toApiJson' in this.oauth2 ? this.oauth2.toApiJson() : this.oauth2;
    }
    return toReturn;
  }
}
class CreateSamlServiceProviderConfigRequest {
  static fromProto(proto) {
    let m = new CreateSamlServiceProviderConfigRequest();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = SamlServiceProviderConfig.fromProto(proto.fields);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    if (typeof this.metadataXmlString !== 'undefined') {
      toReturn['metadataXmlString'] = this.metadataXmlString;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    return toReturn;
  }
}
class CreateSamlServiceProviderConfigResponse {
  static fromProto(proto) {
    let m = new CreateSamlServiceProviderConfigResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderConfigId !== 'undefined') {
      toReturn['serviceProviderConfigId'] = this.serviceProviderConfigId;
    }
    return toReturn;
  }
}
class CreateScopeRequest {
  static fromProto(proto) {
    let m = new CreateScopeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class CreateServiceProviderRequest {
  static fromProto(proto) {
    let m = new CreateServiceProviderRequest();
    m = Object.assign(m, proto);
    if (proto.serviceProvider) {
      m.serviceProvider = ServiceProviderConfig.fromProto(proto.serviceProvider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProvider !== 'undefined' && this.serviceProvider !== null) {
      toReturn['serviceProvider'] = 'toApiJson' in this.serviceProvider ? this.serviceProvider.toApiJson() : this.serviceProvider;
    }
    return toReturn;
  }
}
class DeleteConfigRequest {
  static fromProto(proto) {
    let m = new DeleteConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    return toReturn;
  }
}
class DeleteIdentityProviderConfigurationRequest {
  static fromProto(proto) {
    let m = new DeleteIdentityProviderConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class DeleteSAMLServiceProviderConfigRequest {
  static fromProto(proto) {
    let m = new DeleteSAMLServiceProviderConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderConfigId !== 'undefined') {
      toReturn['serviceProviderConfigId'] = this.serviceProviderConfigId;
    }
    return toReturn;
  }
}
class DeleteScopeRequest {
  static fromProto(proto) {
    let m = new DeleteScopeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scopeId !== 'undefined') {
      toReturn['scopeId'] = this.scopeId;
    }
    return toReturn;
  }
}
class DeleteServiceProviderRequest {
  static fromProto(proto) {
    let m = new DeleteServiceProviderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    return toReturn;
  }
}
class GetEntryURLRequest {
  static fromProto(proto) {
    let m = new GetEntryURLRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = ServiceContext.fromProto(proto.context);
    }
    if (proto.autoImpersonation) {
      m.autoImpersonation = AutoImpersonation.fromProto(proto.autoImpersonation);
    }
    if (proto.noImpersonation) {
      m.noImpersonation = NoImpersonation.fromProto(proto.noImpersonation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    if (typeof this.skipGatewayAuthentication !== 'undefined') {
      toReturn['skipGatewayAuthentication'] = this.skipGatewayAuthentication;
    }
    if (typeof this.impersonateeUserId !== 'undefined') {
      toReturn['impersonateeUserId'] = this.impersonateeUserId;
    }
    if (typeof this.autoImpersonation !== 'undefined' && this.autoImpersonation !== null) {
      toReturn['autoImpersonation'] = 'toApiJson' in this.autoImpersonation ? this.autoImpersonation.toApiJson() : this.autoImpersonation;
    }
    if (typeof this.explicitImpersonateeUserId !== 'undefined') {
      toReturn['explicitImpersonateeUserId'] = this.explicitImpersonateeUserId;
    }
    if (typeof this.noImpersonation !== 'undefined' && this.noImpersonation !== null) {
      toReturn['noImpersonation'] = 'toApiJson' in this.noImpersonation ? this.noImpersonation.toApiJson() : this.noImpersonation;
    }
    return toReturn;
  }
}
class GetEntryURLResponse {
  static fromProto(proto) {
    let m = new GetEntryURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    return toReturn;
  }
}
class GetEntryURLWithCodeRequest {
  static fromProto(proto) {
    let m = new GetEntryURLWithCodeRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = ServiceContext.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.sessionId !== 'undefined') {
      toReturn['sessionId'] = this.sessionId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.nextUrl !== 'undefined') {
      toReturn['nextUrl'] = this.nextUrl;
    }
    if (typeof this.backUrl !== 'undefined') {
      toReturn['backUrl'] = this.backUrl;
    }
    if (typeof this.backUrlText !== 'undefined') {
      toReturn['backUrlText'] = this.backUrlText;
    }
    if (typeof this.federatedIdentityProvider !== 'undefined') {
      toReturn['federatedIdentityProvider'] = this.federatedIdentityProvider;
    }
    if (typeof this.impersonatorUserId !== 'undefined') {
      toReturn['impersonatorUserId'] = this.impersonatorUserId;
    }
    return toReturn;
  }
}
class GetEntryURLWithCodeResponse {
  static fromProto(proto) {
    let m = new GetEntryURLWithCodeResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    return toReturn;
  }
}
class GetIdentityProviderConfigurationRequest {
  static fromProto(proto) {
    let m = new GetIdentityProviderConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetIdentityProviderConfigurationResponse {
  static fromProto(proto) {
    let m = new GetIdentityProviderConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = IdentityProviderConfiguration.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class GetLogoutURLRequest {
  static fromProto(proto) {
    let m = new GetLogoutURLRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = ServiceContext.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sessionId !== 'undefined') {
      toReturn['sessionId'] = this.sessionId;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    return toReturn;
  }
}
class GetLogoutURLResponse {
  static fromProto(proto) {
    let m = new GetLogoutURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.logoutUrl !== 'undefined') {
      toReturn['logoutUrl'] = this.logoutUrl;
    }
    return toReturn;
  }
}
class GetMultiConfigRequest {
  static fromProto(proto) {
    let m = new GetMultiConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.clientIds !== 'undefined') {
      toReturn['clientIds'] = this.clientIds;
    }
    return toReturn;
  }
}
class GetMultiConfigResponse {
  static fromProto(proto) {
    let m = new GetMultiConfigResponse();
    m = Object.assign(m, proto);
    if (proto.configs) {
      m.configs = proto.configs.map(GetMultiConfigResponseConfigContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configs !== 'undefined' && this.configs !== null) {
      toReturn['configs'] = 'toApiJson' in this.configs ? this.configs.toApiJson() : this.configs;
    }
    return toReturn;
  }
}
class GetMultiEntryURLRequest {
  static fromProto(proto) {
    let m = new GetMultiEntryURLRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = ServiceContext.fromProto(proto.context);
    }
    if (proto.autoImpersonation) {
      m.autoImpersonation = AutoImpersonation.fromProto(proto.autoImpersonation);
    }
    if (proto.noImpersonation) {
      m.noImpersonation = NoImpersonation.fromProto(proto.noImpersonation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderIds !== 'undefined') {
      toReturn['serviceProviderIds'] = this.serviceProviderIds;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.impersonateeUserId !== 'undefined') {
      toReturn['impersonateeUserId'] = this.impersonateeUserId;
    }
    if (typeof this.autoImpersonation !== 'undefined' && this.autoImpersonation !== null) {
      toReturn['autoImpersonation'] = 'toApiJson' in this.autoImpersonation ? this.autoImpersonation.toApiJson() : this.autoImpersonation;
    }
    if (typeof this.explicitImpersonateeUserId !== 'undefined') {
      toReturn['explicitImpersonateeUserId'] = this.explicitImpersonateeUserId;
    }
    if (typeof this.noImpersonation !== 'undefined' && this.noImpersonation !== null) {
      toReturn['noImpersonation'] = 'toApiJson' in this.noImpersonation ? this.noImpersonation.toApiJson() : this.noImpersonation;
    }
    return toReturn;
  }
}
class GetMultiEntryURLResponse {
  static fromProto(proto) {
    let m = new GetMultiEntryURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.entryUrls !== 'undefined') {
      toReturn['entryUrls'] = this.entryUrls;
    }
    return toReturn;
  }
}
class GetMultiScopeRequest {
  static fromProto(proto) {
    let m = new GetMultiScopeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scopeIds !== 'undefined') {
      toReturn['scopeIds'] = this.scopeIds;
    }
    return toReturn;
  }
}
class GetMultiScopeResponse {
  static fromProto(proto) {
    let m = new GetMultiScopeResponse();
    m = Object.assign(m, proto);
    if (proto.scopes) {
      m.scopes = proto.scopes.map(GetMultiScopeResponseScopeContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scopes !== 'undefined' && this.scopes !== null) {
      toReturn['scopes'] = 'toApiJson' in this.scopes ? this.scopes.toApiJson() : this.scopes;
    }
    return toReturn;
  }
}
class GetSAMLIdentityProviderMetadataRequest {
  static fromProto(proto) {
    let m = new GetSAMLIdentityProviderMetadataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderConfigId !== 'undefined') {
      toReturn['serviceProviderConfigId'] = this.serviceProviderConfigId;
    }
    return toReturn;
  }
}
class GetSAMLIdentityProviderMetadataResponse {
  static fromProto(proto) {
    let m = new GetSAMLIdentityProviderMetadataResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metadata !== 'undefined') {
      toReturn['metadata'] = this.metadata;
    }
    return toReturn;
  }
}
class GetServiceProviderRequest {
  static fromProto(proto) {
    let m = new GetServiceProviderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    return toReturn;
  }
}
class GetServiceProviderResponse {
  static fromProto(proto) {
    let m = new GetServiceProviderResponse();
    m = Object.assign(m, proto);
    if (proto.serviceProvider) {
      m.serviceProvider = ServiceProviderConfig.fromProto(proto.serviceProvider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProvider !== 'undefined' && this.serviceProvider !== null) {
      toReturn['serviceProvider'] = 'toApiJson' in this.serviceProvider ? this.serviceProvider.toApiJson() : this.serviceProvider;
    }
    return toReturn;
  }
}
class GetSessionTransferURLRequest {
  static fromProto(proto) {
    let m = new GetSessionTransferURLRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = ServiceContext.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    return toReturn;
  }
}
class GetSessionTransferURLResponse {
  static fromProto(proto) {
    let m = new GetSessionTransferURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sessionTransferUrl !== 'undefined') {
      toReturn['sessionTransferUrl'] = this.sessionTransferUrl;
    }
    return toReturn;
  }
}
class HasCustomIdentityProviderRequest {
  static fromProto(proto) {
    let m = new HasCustomIdentityProviderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    return toReturn;
  }
}
class HasCustomIdentityProviderResponse {
  static fromProto(proto) {
    let m = new HasCustomIdentityProviderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hasCustomIdp !== 'undefined') {
      toReturn['hasCustomIdp'] = this.hasCustomIdp;
    }
    return toReturn;
  }
}
class ListConfigsRequest {
  static fromProto(proto) {
    let m = new ListConfigsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListConfigsResponse {
  static fromProto(proto) {
    let m = new ListConfigsResponse();
    m = Object.assign(m, proto);
    if (proto.clientConfigurations) {
      m.clientConfigurations = proto.clientConfigurations.map(Oauth2Config.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.clientConfigurations !== 'undefined' && this.clientConfigurations !== null) {
      toReturn['clientConfigurations'] = 'toApiJson' in this.clientConfigurations ? this.clientConfigurations.toApiJson() : this.clientConfigurations;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListSAMLServiceProviderConfigsRequest {
  static fromProto(proto) {
    let m = new ListSAMLServiceProviderConfigsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListSAMLServiceProviderConfigsResponse {
  static fromProto(proto) {
    let m = new ListSAMLServiceProviderConfigsResponse();
    m = Object.assign(m, proto);
    if (proto.serviceProviderConfigs) {
      m.serviceProviderConfigs = proto.serviceProviderConfigs.map(SamlServiceProviderConfig.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderConfigs !== 'undefined' && this.serviceProviderConfigs !== null) {
      toReturn['serviceProviderConfigs'] = 'toApiJson' in this.serviceProviderConfigs ? this.serviceProviderConfigs.toApiJson() : this.serviceProviderConfigs;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListScopesRequest {
  static fromProto(proto) {
    let m = new ListScopesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListScopesResponse {
  static fromProto(proto) {
    let m = new ListScopesResponse();
    m = Object.assign(m, proto);
    if (proto.scopes) {
      m.scopes = proto.scopes.map(Scope.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scopes !== 'undefined' && this.scopes !== null) {
      toReturn['scopes'] = 'toApiJson' in this.scopes ? this.scopes.toApiJson() : this.scopes;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListServiceProvidersRequest {
  static fromProto(proto) {
    let m = new ListServiceProvidersRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListServiceProvidersResponse {
  static fromProto(proto) {
    let m = new ListServiceProvidersResponse();
    m = Object.assign(m, proto);
    if (proto.serviceProviders) {
      m.serviceProviders = proto.serviceProviders.map(ServiceProviderConfig.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviders !== 'undefined' && this.serviceProviders !== null) {
      toReturn['serviceProviders'] = 'toApiJson' in this.serviceProviders ? this.serviceProviders.toApiJson() : this.serviceProviders;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class LogoutRequest {
  static fromProto(proto) {
    let m = new LogoutRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sessionId !== 'undefined') {
      toReturn['sessionId'] = this.sessionId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class UpdateScopeRequestMutation {
  static fromProto(proto) {
    let m = new UpdateScopeRequestMutation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class UpdateIdentityProviderConfigurationRequestMutation {
  static fromProto(proto) {
    let m = new UpdateIdentityProviderConfigurationRequestMutation();
    m = Object.assign(m, proto);
    if (proto.openId) {
      m.openId = UpdateIdentityProviderConfigurationRequestMutationOpenIDConnectConfigurationMutation.fromProto(proto.openId);
    }
    if (proto.replaceOpenId) {
      m.replaceOpenId = OpenIDConnectConfiguration.fromProto(proto.replaceOpenId);
    }
    if (proto.oauth2) {
      m.oauth2 = UpdateIdentityProviderConfigurationRequestMutationOAuth2ConfigurationMutation.fromProto(proto.oauth2);
    }
    if (proto.replaceOauth2) {
      m.replaceOauth2 = OAuth2Configuration.fromProto(proto.replaceOauth2);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.clientSecret !== 'undefined') {
      toReturn['clientSecret'] = this.clientSecret;
    }
    if (typeof this.openId !== 'undefined' && this.openId !== null) {
      toReturn['openId'] = 'toApiJson' in this.openId ? this.openId.toApiJson() : this.openId;
    }
    if (typeof this.replaceOpenId !== 'undefined' && this.replaceOpenId !== null) {
      toReturn['replaceOpenId'] = 'toApiJson' in this.replaceOpenId ? this.replaceOpenId.toApiJson() : this.replaceOpenId;
    }
    if (typeof this.oauth2 !== 'undefined' && this.oauth2 !== null) {
      toReturn['oauth2'] = 'toApiJson' in this.oauth2 ? this.oauth2.toApiJson() : this.oauth2;
    }
    if (typeof this.replaceOauth2 !== 'undefined' && this.replaceOauth2 !== null) {
      toReturn['replaceOauth2'] = 'toApiJson' in this.replaceOauth2 ? this.replaceOauth2.toApiJson() : this.replaceOauth2;
    }
    return toReturn;
  }
}
class UpdateConfigRequestMutation {
  static fromProto(proto) {
    let m = new UpdateConfigRequestMutation();
    m = Object.assign(m, proto);
    if (proto.redirectUris) {
      m.redirectUris = UpdateConfigRequestMutationRepeatedStringMutation.fromProto(proto.redirectUris);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.redirectUris !== 'undefined' && this.redirectUris !== null) {
      toReturn['redirectUris'] = 'toApiJson' in this.redirectUris ? this.redirectUris.toApiJson() : this.redirectUris;
    }
    if (typeof this.logoutUri !== 'undefined') {
      toReturn['logoutUri'] = this.logoutUri;
    }
    return toReturn;
  }
}
class UpdateServiceProviderRequestMutation {
  static fromProto(proto) {
    let m = new UpdateServiceProviderRequestMutation();
    m = Object.assign(m, proto);
    if (proto.alternativeDomains) {
      m.alternativeDomains = UpdateServiceProviderRequestMutationRepeatedStringMutation.fromProto(proto.alternativeDomains);
    }
    if (proto.serviceProviderType) {
      m.serviceProviderType = enumStringToValue$1(ServiceProviderType, proto.serviceProviderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    if (typeof this.sessionUrl !== 'undefined') {
      toReturn['sessionUrl'] = this.sessionUrl;
    }
    if (typeof this.primaryDomain !== 'undefined') {
      toReturn['primaryDomain'] = this.primaryDomain;
    }
    if (typeof this.alternativeDomains !== 'undefined' && this.alternativeDomains !== null) {
      toReturn['alternativeDomains'] = 'toApiJson' in this.alternativeDomains ? this.alternativeDomains.toApiJson() : this.alternativeDomains;
    }
    if (typeof this.ownedAndOperated !== 'undefined') {
      toReturn['ownedAndOperated'] = this.ownedAndOperated;
    }
    if (typeof this.logoutUrl !== 'undefined') {
      toReturn['logoutUrl'] = this.logoutUrl;
    }
    if (typeof this.serviceProviderType !== 'undefined') {
      toReturn['serviceProviderType'] = this.serviceProviderType;
    }
    return toReturn;
  }
}
class UpdateIdentityProviderConfigurationRequestMutationOAuth2ConfigurationMutation {
  static fromProto(proto) {
    let m = new UpdateIdentityProviderConfigurationRequestMutationOAuth2ConfigurationMutation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.authorizationEndpoint !== 'undefined') {
      toReturn['authorizationEndpoint'] = this.authorizationEndpoint;
    }
    if (typeof this.tokenEndpoint !== 'undefined') {
      toReturn['tokenEndpoint'] = this.tokenEndpoint;
    }
    if (typeof this.userinfoEndpoint !== 'undefined') {
      toReturn['userinfoEndpoint'] = this.userinfoEndpoint;
    }
    return toReturn;
  }
}
class UpdateIdentityProviderConfigurationRequestMutationOpenIDConnectConfigurationMutation {
  static fromProto(proto) {
    let m = new UpdateIdentityProviderConfigurationRequestMutationOpenIDConnectConfigurationMutation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.discoveryEndpoint !== 'undefined') {
      toReturn['discoveryEndpoint'] = this.discoveryEndpoint;
    }
    return toReturn;
  }
}
class RegenerateSAMLServiceProviderConfigCertificateRequest {
  static fromProto(proto) {
    let m = new RegenerateSAMLServiceProviderConfigCertificateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProviderConfigId !== 'undefined') {
      toReturn['serviceProviderConfigId'] = this.serviceProviderConfigId;
    }
    return toReturn;
  }
}
class RegenerateSAMLServiceProviderConfigCertificateResponse {
  static fromProto(proto) {
    let m = new RegenerateSAMLServiceProviderConfigCertificateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.certificate !== 'undefined') {
      toReturn['certificate'] = this.certificate;
    }
    return toReturn;
  }
}
class UpdateServiceProviderRequestMutationRepeatedStringMutation {
  static fromProto(proto) {
    let m = new UpdateServiceProviderRequestMutationRepeatedStringMutation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.repeatedString !== 'undefined') {
      toReturn['repeatedString'] = this.repeatedString;
    }
    return toReturn;
  }
}
class UpdateConfigRequestMutationRepeatedStringMutation {
  static fromProto(proto) {
    let m = new UpdateConfigRequestMutationRepeatedStringMutation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.repeatedString !== 'undefined') {
      toReturn['repeatedString'] = this.repeatedString;
    }
    return toReturn;
  }
}
class RevokeGrantRequest {
  static fromProto(proto) {
    let m = new RevokeGrantRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.scopeIds !== 'undefined') {
      toReturn['scopeIds'] = this.scopeIds;
    }
    return toReturn;
  }
}
class GetMultiScopeResponseScopeContainer {
  static fromProto(proto) {
    let m = new GetMultiScopeResponseScopeContainer();
    m = Object.assign(m, proto);
    if (proto.scope) {
      m.scope = Scope.fromProto(proto.scope);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined' && this.scope !== null) {
      toReturn['scope'] = 'toApiJson' in this.scope ? this.scope.toApiJson() : this.scope;
    }
    return toReturn;
  }
}
class UpdateConfigRequest {
  static fromProto(proto) {
    let m = new UpdateConfigRequest();
    m = Object.assign(m, proto);
    if (proto.mutations) {
      m.mutations = proto.mutations.map(UpdateConfigRequestMutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    return toReturn;
  }
}
class UpdateIdentityProviderConfigurationRequest {
  static fromProto(proto) {
    let m = new UpdateIdentityProviderConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.mutations) {
      m.mutations = proto.mutations.map(UpdateIdentityProviderConfigurationRequestMutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    return toReturn;
  }
}
class UpdateSAMLServiceProviderConfigRequest {
  static fromProto(proto) {
    let m = new UpdateSAMLServiceProviderConfigRequest();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = SamlServiceProviderConfig.fromProto(proto.fields);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    if (typeof this.metadataXmlString !== 'undefined') {
      toReturn['metadataXmlString'] = this.metadataXmlString;
    }
    if (typeof this.serviceProviderConfigId !== 'undefined') {
      toReturn['serviceProviderConfigId'] = this.serviceProviderConfigId;
    }
    return toReturn;
  }
}
class UpdateScopeRequest {
  static fromProto(proto) {
    let m = new UpdateScopeRequest();
    m = Object.assign(m, proto);
    if (proto.mutations) {
      m.mutations = proto.mutations.map(UpdateScopeRequestMutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scopeId !== 'undefined') {
      toReturn['scopeId'] = this.scopeId;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    return toReturn;
  }
}
class UpdateServiceProviderRequest {
  static fromProto(proto) {
    let m = new UpdateServiceProviderRequest();
    m = Object.assign(m, proto);
    if (proto.serviceProvider) {
      m.serviceProvider = ServiceProviderConfig.fromProto(proto.serviceProvider);
    }
    if (proto.mutations) {
      m.mutations = proto.mutations.map(UpdateServiceProviderRequestMutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceProvider !== 'undefined' && this.serviceProvider !== null) {
      toReturn['serviceProvider'] = 'toApiJson' in this.serviceProvider ? this.serviceProvider.toApiJson() : this.serviceProvider;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    return toReturn;
  }
}
class ConsumeSingleUseTokenRequest {
  static fromProto(proto) {
    let m = new ConsumeSingleUseTokenRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userID !== 'undefined') {
      toReturn['userID'] = this.userID;
    }
    if (typeof this.otp !== 'undefined') {
      toReturn['otp'] = this.otp;
    }
    if (typeof this.nextUrl !== 'undefined') {
      toReturn['nextUrl'] = this.nextUrl;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': '',
  'test': '',
  'demo': 'sso-api-demo.apigateway.co',
  'prod': 'sso-api-prod.apigateway.co',
  'production': 'sso-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ConsentApiService = /*#__PURE__*/(() => {
  class ConsentApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    revokeGrant(r) {
      const request = r.toApiJson ? r : new RevokeGrantRequest(r);
      return this.http.post(this._host + "/sso.v1.Consent/RevokeGrant", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ConsentApiService.ɵfac = function ConsentApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ConsentApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ConsentApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConsentApiService,
    factory: ConsentApiService.ɵfac,
    providedIn: 'root'
  });
  return ConsentApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ConsentAdminApiService = /*#__PURE__*/(() => {
  class ConsentAdminApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createScope(r) {
      const request = r.toApiJson ? r : new CreateScopeRequest(r);
      return this.http.post(this._host + "/sso.v1.ConsentAdmin/CreateScope", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateScope(r) {
      const request = r.toApiJson ? r : new UpdateScopeRequest(r);
      return this.http.post(this._host + "/sso.v1.ConsentAdmin/UpdateScope", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiScope(r) {
      const request = r.toApiJson ? r : new GetMultiScopeRequest(r);
      return this.http.post(this._host + "/sso.v1.ConsentAdmin/GetMultiScope", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiScopeResponse.fromProto(resp)));
    }
    listScopes(r) {
      const request = r.toApiJson ? r : new ListScopesRequest(r);
      return this.http.post(this._host + "/sso.v1.ConsentAdmin/ListScopes", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListScopesResponse.fromProto(resp)));
    }
    deleteScope(r) {
      const request = r.toApiJson ? r : new DeleteScopeRequest(r);
      return this.http.post(this._host + "/sso.v1.ConsentAdmin/DeleteScope", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ConsentAdminApiService.ɵfac = function ConsentAdminApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ConsentAdminApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ConsentAdminApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConsentAdminApiService,
    factory: ConsentAdminApiService.ɵfac,
    providedIn: 'root'
  });
  return ConsentAdminApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let IdentityProviderApiService = /*#__PURE__*/(() => {
  class IdentityProviderApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getEntryUrl(r) {
      const request = r.toApiJson ? r : new GetEntryURLRequest(r);
      return this.http.post(this._host + "/sso.v1.IdentityProvider/GetEntryURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEntryURLResponse.fromProto(resp)));
    }
    getMultiEntryUrl(r) {
      const request = r.toApiJson ? r : new GetMultiEntryURLRequest(r);
      return this.http.post(this._host + "/sso.v1.IdentityProvider/GetMultiEntryURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiEntryURLResponse.fromProto(resp)));
    }
    getEntryUrlWithCode(r) {
      const request = r.toApiJson ? r : new GetEntryURLWithCodeRequest(r);
      return this.http.post(this._host + "/sso.v1.IdentityProvider/GetEntryURLWithCode", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEntryURLWithCodeResponse.fromProto(resp)));
    }
    logout(r) {
      const request = r.toApiJson ? r : new LogoutRequest(r);
      return this.http.post(this._host + "/sso.v1.IdentityProvider/Logout", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    consumeSingleUseToken(r) {
      const toApiJson = r.toApiJson;
      const request = typeof toApiJson !== 'undefined' ? r : new ConsumeSingleUseTokenRequest(r);
      const params = new URLSearchParams();
      const apiJson = request.toApiJson();
      for (const key in apiJson) {
        if (!apiJson.hasOwnProperty(key)) {
          continue;
        }
        const value = apiJson[key];
        if (value === null) {
          continue;
        }
        params.append(key, value);
      }
      window.location.href = `${this._host}/single-use-token?${params.toString()}`;
    }
  }
  IdentityProviderApiService.ɵfac = function IdentityProviderApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IdentityProviderApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IdentityProviderApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IdentityProviderApiService,
    factory: IdentityProviderApiService.ɵfac,
    providedIn: 'root'
  });
  return IdentityProviderApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let IdentityProviderAdminApiService = /*#__PURE__*/(() => {
  class IdentityProviderAdminApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createIdentityProvider(r) {
      const request = r.toApiJson ? r : new CreateIdentityProviderConfigurationRequest(r);
      return this.http.post(this._host + "/sso.v1.IdentityProviderAdmin/CreateIdentityProvider", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateIdentityProvider(r) {
      const request = r.toApiJson ? r : new UpdateIdentityProviderConfigurationRequest(r);
      return this.http.post(this._host + "/sso.v1.IdentityProviderAdmin/UpdateIdentityProvider", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getIdentityProvider(r) {
      const request = r.toApiJson ? r : new GetIdentityProviderConfigurationRequest(r);
      return this.http.post(this._host + "/sso.v1.IdentityProviderAdmin/GetIdentityProvider", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetIdentityProviderConfigurationResponse.fromProto(resp)));
    }
    deleteIdentityProvider(r) {
      const request = r.toApiJson ? r : new DeleteIdentityProviderConfigurationRequest(r);
      return this.http.post(this._host + "/sso.v1.IdentityProviderAdmin/DeleteIdentityProvider", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    hasCustomIdentityProvider(r) {
      const request = r.toApiJson ? r : new HasCustomIdentityProviderRequest(r);
      return this.http.post(this._host + "/sso.v1.IdentityProviderAdmin/HasCustomIdentityProvider", request.toApiJson(), this.apiOptions()).pipe(map(resp => HasCustomIdentityProviderResponse.fromProto(resp)));
    }
  }
  IdentityProviderAdminApiService.ɵfac = function IdentityProviderAdminApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IdentityProviderAdminApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IdentityProviderAdminApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IdentityProviderAdminApiService,
    factory: IdentityProviderAdminApiService.ɵfac,
    providedIn: 'root'
  });
  return IdentityProviderAdminApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ServiceProviderApiService = /*#__PURE__*/(() => {
  class ServiceProviderApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getSessionTransferUrl(r) {
      const request = r.toApiJson ? r : new GetSessionTransferURLRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProvider/GetSessionTransferURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSessionTransferURLResponse.fromProto(resp)));
    }
    getLogoutUrl(r) {
      const request = r.toApiJson ? r : new GetLogoutURLRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProvider/GetLogoutURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLogoutURLResponse.fromProto(resp)));
    }
  }
  ServiceProviderApiService.ɵfac = function ServiceProviderApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ServiceProviderApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ServiceProviderApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ServiceProviderApiService,
    factory: ServiceProviderApiService.ɵfac,
    providedIn: 'root'
  });
  return ServiceProviderApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ServiceProviderAdminApiService = /*#__PURE__*/(() => {
  class ServiceProviderAdminApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createServiceProvider(r) {
      const request = r.toApiJson ? r : new CreateServiceProviderRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/CreateServiceProvider", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getServiceProvider(r) {
      const request = r.toApiJson ? r : new GetServiceProviderRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/GetServiceProvider", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetServiceProviderResponse.fromProto(resp)));
    }
    updateServiceProvider(r) {
      const request = r.toApiJson ? r : new UpdateServiceProviderRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/UpdateServiceProvider", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteServiceProvider(r) {
      const request = r.toApiJson ? r : new DeleteServiceProviderRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/DeleteServiceProvider", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listServiceProviders(r) {
      const request = r.toApiJson ? r : new ListServiceProvidersRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/ListServiceProviders", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListServiceProvidersResponse.fromProto(resp)));
    }
    createConfig(r) {
      const request = r.toApiJson ? r : new CreateConfigRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/CreateConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateConfigResponse.fromProto(resp)));
    }
    getMultiConfig(r) {
      const request = r.toApiJson ? r : new GetMultiConfigRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/GetMultiConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiConfigResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateConfigRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteConfig(r) {
      const request = r.toApiJson ? r : new DeleteConfigRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/DeleteConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listConfigs(r) {
      const request = r.toApiJson ? r : new ListConfigsRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/ListConfigs", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListConfigsResponse.fromProto(resp)));
    }
    createSamlServiceProviderConfig(r) {
      const request = r.toApiJson ? r : new CreateSamlServiceProviderConfigRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/CreateSamlServiceProviderConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSamlServiceProviderConfigResponse.fromProto(resp)));
    }
    getSamlIdentityProviderMetadata(r) {
      const request = r.toApiJson ? r : new GetSAMLIdentityProviderMetadataRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/GetSAMLIdentityProviderMetadata", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSAMLIdentityProviderMetadataResponse.fromProto(resp)));
    }
    updateSamlServiceProviderConfig(r) {
      const request = r.toApiJson ? r : new UpdateSAMLServiceProviderConfigRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/UpdateSAMLServiceProviderConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listSamlServiceProviderConfigs(r) {
      const request = r.toApiJson ? r : new ListSAMLServiceProviderConfigsRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/ListSAMLServiceProviderConfigs", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSAMLServiceProviderConfigsResponse.fromProto(resp)));
    }
    regenerateSamlServiceProviderConfigCertificate(r) {
      const request = r.toApiJson ? r : new RegenerateSAMLServiceProviderConfigCertificateRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/RegenerateSAMLServiceProviderConfigCertificate", request.toApiJson(), this.apiOptions()).pipe(map(resp => RegenerateSAMLServiceProviderConfigCertificateResponse.fromProto(resp)));
    }
    deleteSamlServiceProviderConfig(r) {
      const request = r.toApiJson ? r : new DeleteSAMLServiceProviderConfigRequest(r);
      return this.http.post(this._host + "/sso.v1.ServiceProviderAdmin/DeleteSAMLServiceProviderConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ServiceProviderAdminApiService.ɵfac = function ServiceProviderAdminApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ServiceProviderAdminApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ServiceProviderAdminApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ServiceProviderAdminApiService,
    factory: ServiceProviderAdminApiService.ɵfac,
    providedIn: 'root'
  });
  return ServiceProviderAdminApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

const ImpersonationTypeNone = 'none';
const ImpersonationTypeAuto = 'auto';
const serviceGatewayPath = "/service-gateway";
let SSOService = /*#__PURE__*/(() => {
  class SSOService {
    constructor(identityProviderApiService, consentAdminApiService, serviceProviderApiService, hostService) {
      this.identityProviderApiService = identityProviderApiService;
      this.consentAdminApiService = consentAdminApiService;
      this.serviceProviderApiService = serviceProviderApiService;
      this.hostService = hostService;
    }
    getEntryUrl(serviceProviderId, context, options = {}) {
      const request = new GetEntryURLRequest({
        serviceProviderId: serviceProviderId,
        context: context,
        skipGatewayAuthentication: options.skipGatewayAuthentication,
        path: options.path
      });
      switch (options.impersonation) {
        case 'none':
          request.noImpersonation = new NoImpersonation();
          break;
        case 'auto':
          request.autoImpersonation = new AutoImpersonation();
          break;
        // Use the proto/server default.
        case undefined:
          break;
        case null:
          break;
        default:
          request.explicitImpersonateeUserId = options.impersonation;
          break;
      }
      return this.identityProviderApiService.getEntryUrl(request).pipe(map(resp => resp.entryUrl), share());
    }
    getMultiEntryUrl(serviceProviderIds, context, options = {}) {
      const request = new GetMultiEntryURLRequest({
        serviceProviderIds: serviceProviderIds,
        context: context
      });
      switch (options.impersonation) {
        case 'none':
          request.noImpersonation = new NoImpersonation();
          break;
        case 'auto':
          request.autoImpersonation = new AutoImpersonation();
          break;
        // Use the proto/server default.
        case undefined:
          break;
        case null:
          break;
        default:
          request.explicitImpersonateeUserId = options.impersonation;
          break;
      }
      return this.identityProviderApiService.getMultiEntryUrl(request).pipe(map(resp => resp.entryUrls || []), share());
    }
    getMultiScope(scopeIds) {
      const request = new GetMultiScopeRequest({
        scopeIds: scopeIds
      });
      return this.consentAdminApiService.getMultiScope(request).pipe(map(resp => resp.scopes));
    }
    getSessionTransferURL(serviceProviderId, context) {
      const request = new GetSessionTransferURLRequest({
        serviceProviderId: serviceProviderId,
        context: context
      });
      return this.serviceProviderApiService.getSessionTransferUrl(request);
    }
    consumeSingleUseToken(userID, otp, nextUrl) {
      const request = new ConsumeSingleUseTokenRequest({
        userID: userID,
        otp: otp,
        nextUrl: nextUrl
      });
      this.identityProviderApiService.consumeSingleUseToken(request);
    }
    getServiceGatewayURLForAccount(serviceProviderID, accountID, nextPath) {
      const host = this.hostService.hostWithScheme;
      const query = new URLSearchParams({
        serviceProviderId: serviceProviderID,
        account_id: accountID
      });
      if (nextPath) {
        query.set("path", nextPath);
      }
      return host + serviceGatewayPath + "?" + query.toString();
    }
    getServiceGatewayURLForGroupPath(serviceProviderID, groupPath, nextPath) {
      const host = this.hostService.hostWithScheme;
      const query = new URLSearchParams({
        serviceProviderId: serviceProviderID,
        group_path: groupPath
      });
      if (nextPath) {
        query.set("path", nextPath);
      }
      return host + serviceGatewayPath + "?" + query.toString();
    }
  }
  SSOService.ɵfac = function SSOService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SSOService)(i0.ɵɵinject(IdentityProviderApiService), i0.ɵɵinject(ConsentAdminApiService), i0.ɵɵinject(ServiceProviderApiService), i0.ɵɵinject(HostService));
  };
  SSOService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SSOService,
    factory: SSOService.ɵfac,
    providedIn: 'root'
  });
  return SSOService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function newAccountServiceContext(accountId) {
  return new ServiceContext({
    account: new ServiceContextAccount({
      accountId: accountId
    })
  });
}
function newPartnerServiceContext(partnerId) {
  return new ServiceContext({
    partner: new ServiceContextPartner({
      partnerId: partnerId
    })
  });
}
function newSuperAdminServiceContext() {
  return new ServiceContext({
    superAdmin: new ServiceContextSuperAdmin()
  });
}

// DEPRECATED, use ServiceContextPartner
const Partner = ServiceContextPartner;

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AcsUrl, AutoImpersonation, ConsentAdminApiService, ConsentApiService, ConsumeSingleUseTokenRequest, CreateConfigRequest, CreateConfigResponse, CreateIdentityProviderConfigurationRequest, CreateSamlServiceProviderConfigRequest, CreateSamlServiceProviderConfigResponse, CreateScopeRequest, CreateServiceProviderRequest, DeleteConfigRequest, DeleteIdentityProviderConfigurationRequest, DeleteSAMLServiceProviderConfigRequest, DeleteScopeRequest, DeleteServiceProviderRequest, FieldMask, GetEntryURLRequest, GetEntryURLResponse, GetEntryURLWithCodeRequest, GetEntryURLWithCodeResponse, GetIdentityProviderConfigurationRequest, GetIdentityProviderConfigurationResponse, GetLogoutURLRequest, GetLogoutURLResponse, GetMultiConfigRequest, GetMultiConfigResponse, GetMultiConfigResponseConfigContainer, GetMultiEntryURLRequest, GetMultiEntryURLResponse, GetMultiScopeRequest, GetMultiScopeResponse, GetMultiScopeResponseScopeContainer, GetSAMLIdentityProviderMetadataRequest, GetSAMLIdentityProviderMetadataResponse, GetServiceProviderRequest, GetServiceProviderResponse, GetSessionTransferURLRequest, GetSessionTransferURLResponse, HasCustomIdentityProviderRequest, HasCustomIdentityProviderResponse, HostService, IdentityProviderAdminApiService, IdentityProviderApiService, IdentityProviderConfiguration, ListConfigsRequest, ListConfigsResponse, ListSAMLServiceProviderConfigsRequest, ListSAMLServiceProviderConfigsResponse, ListScopesRequest, ListScopesResponse, ListServiceProvidersRequest, ListServiceProvidersResponse, LogoutRequest, NoImpersonation, OAuth2Configuration, Oauth2Config, OpenIDConnectConfiguration, Partner, RegenerateSAMLServiceProviderConfigCertificateRequest, RegenerateSAMLServiceProviderConfigCertificateResponse, RevokeGrantRequest, SSOService, SamlServiceProviderConfig, Scope, ServiceContext, ServiceContextAccount, ServiceContextBrand, ServiceContextPartner, ServiceContextSuperAdmin, ServiceProviderAdminApiService, ServiceProviderApiService, ServiceProviderConfig, ServiceProviderType, UpdateConfigRequest, UpdateConfigRequestMutation, UpdateConfigRequestMutationRepeatedStringMutation, UpdateIdentityProviderConfigurationRequest, UpdateIdentityProviderConfigurationRequestMutation, UpdateIdentityProviderConfigurationRequestMutationOAuth2ConfigurationMutation, UpdateIdentityProviderConfigurationRequestMutationOpenIDConnectConfigurationMutation, UpdateSAMLServiceProviderConfigRequest, UpdateScopeRequest, UpdateScopeRequestMutation, UpdateServiceProviderRequest, UpdateServiceProviderRequestMutation, UpdateServiceProviderRequestMutationRepeatedStringMutation, newAccountServiceContext, newPartnerServiceContext, newSuperAdminServiceContext };
